module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "input title",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": _vm.playlist.name
    },
    on: {
      "input": function($event) {
        return _vm.updateName($event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.playlist || !_vm.playlist.id) ? _c('b-field', {
    attrs: {
      "label": "Create from template :"
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "rounded": "",
      "open-on-focus": true,
      "data": _vm.filteredTemplates,
      "placeholder": "Template name",
      "icon": "magnify",
      "field": "name"
    },
    on: {
      "select": function($event) {
        return _vm.updateTemplate($event)
      }
    },
    model: {
      value: (_vm.templateName),
      callback: function($$v) {
        _vm.templateName = $$v
      },
      expression: "templateName"
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("\n        No results for " + _vm._s(_vm.templateName) + "\n      ")])], 2)], 1) : _c('div', [_c('draggable-playlist-items', {
    attrs: {
      "has-delete": true,
      "draggable": true
    },
    on: {
      "deleteItem": function($event) {
        return _vm.handleRemovePlaylistItem($event)
      },
      "itemClick": function($event) {
        return _vm.editPlaylistItem(_vm.playlist, $event)
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": {
        path: '/playlists/' + _vm.playlist.id + '/new-item'
      }
    }
  }, [_c('span', [_vm._v("+")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40b49c3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaylistEdit.vue
// module id = 316
// module chunks = 2